const parseQueryParameter = (search) => {
    return new URLSearchParams(search);
};

export default parseQueryParameter;